export default function SectionHeading({ overline, title, subtitle, align = "left", light = false, className = "" }) {
  const center = align === "center";
  return (
    <div className={`${center ? "text-center mx-auto max-w-3xl" : "max-w-2xl"} ${className}`}>
      {overline && (
        <p className="overline-label mb-3" style={light ? { color: "#16B8D4" } : undefined}>
          {overline}
        </p>
      )}
      <h2
        className="font-heading text-3xl sm:text-4xl lg:text-[2.6rem] font-extrabold tracking-tight leading-tight"
        style={{ color: light ? "#FFFFFF" : "#063B63" }}
      >
        {title}
      </h2>
      {subtitle && (
        <p className="mt-4 text-base md:text-lg" style={{ color: light ? "rgba(255,255,255,0.82)" : "#4A6B82" }}>
          {subtitle}
        </p>
      )}
    </div>
  );
}
